import store from '@/store'
import QuizStatuses from '@/constants/QuizStatuses'
import storage from '@/services/storage'
import EventBus from '@/eventBus'

let preQuestionTimeout
let showQuestionTimeout
let showResultTimeout

function _switchQuizScreen(quizStatus) {
  store.dispatch('updateSlide', {
    quizStatus,
  })
}

function _isAudienceFormShowing() {
  if (store.state.presentation.teamPlay) {
    return (
      !store.state.audienceName ||
      !store.state.isAudienceEmojiDisabled ||
      !store.state.audienceQuizTeam
    )
  }
  return (
    !store.state.audienceName ||
    !store.state.isAudienceEmojiDisabled
  )
}

function clearSelfPaceTimeouts() {
  if (preQuestionTimeout) {
    window.clearTimeout(preQuestionTimeout)
  }
  if (showQuestionTimeout) {
    window.clearTimeout(showQuestionTimeout)
  }
  if (showResultTimeout) {
    window.clearTimeout(showResultTimeout)
  }
}

function _isQuizAnswered(presentation, slide) {
  const answeredSlideIds = storage.getValueByPresentation(presentation.id, 'answeredSlideIds', [])
  return answeredSlideIds.includes(slide.id)
}

// A positive per-question time limit — the anchor the timed self-paced flow needs to
// end the round. Absent it, _showSelfPacedQuestion's timer is NaN and would snap
// straight to RESULT (AHAM-769).
function _hasSelfPacedTimeLimit(slide) {
  const timeToAnswer = Number(slide?.timeToAnswer)
  return Number.isFinite(timeToAnswer) && timeToAnswer > 0
}

function _setupQuizCountdownTimer(slide) {
  store.getters.activeActivity.quizTimestamp = [new Date().getTime()]
  store.state.countdownTimeToAnswer = slide.timeToAnswer
}

function _showSelfPacedQuestion(presentation, slide) {
  _switchQuizScreen(QuizStatuses.QUESTION_SCREEN)

  _setupQuizCountdownTimer(slide)

  // Wait for the question countdown timer to show result
  showResultTimeout = window.setTimeout(() => {
    _switchQuizScreen(QuizStatuses.RESULT_SCREEN)
    // If not answer, emit the quizTimeout event to call /api/answer/create
    if (!_isQuizAnswered(presentation, slide)) {
      setTimeout(() => {
        EventBus.$emit('quizTimeout', slide.id)
      }, 500)
    }
  }, slide.timeToAnswer * 1000 + 500)
}

function _prepareToShowQuestion(presentation, slide) {
  // Wait for 3s before showing the question
  preQuestionTimeout = window.setTimeout(() => {
    if (presentation.enableQuizCoundown) {
      _switchQuizScreen(QuizStatuses.COUNTDOWN_5S_SCREEN)
      EventBus.$emit('startQuizScreenTwo', slide.id)
      showQuestionTimeout = window.setTimeout(() => {
        _showSelfPacedQuestion(presentation, slide)
      }, 5e3)
    } else {
      _showSelfPacedQuestion(presentation, slide)
    }
  }, 3e3)
}

/**
 * @deprecated
 * this method set quiz status to rule screen
 * unnecessary even when the question is already answered
 */
function playSelfPacedQuizSlideV1(presentation, slide) {
  clearSelfPaceTimeouts()

  // If the presentation not enable Self-paced mode,
  // or not join presentation,
  // or not quiz slide, skip
  if (
    _isAudienceFormShowing() ||
    !presentation.audiencePacing ||
    slide.type !== 'pickAnswer'
  ) {
    return
  }

  _switchQuizScreen(QuizStatuses.RULE_SCREEN)

  if (_isQuizAnswered(presentation, slide)) {
    _switchQuizScreen(QuizStatuses.RESULT_SCREEN)
  } else {
    _prepareToShowQuestion(presentation, slide)
  }
}

function getSelfPacedQuizStatus(presentation, slide) {
  if (!presentation?.audiencePacing ||
    !store.getters.isQuizSlide(slide)) {
    return undefined
  }

  if (_isQuizAnswered(presentation, slide)) {
    return QuizStatuses.RESULT_SCREEN
  }
  // Plugin quizzes render their question INSIDE the iframe. With a time limit they
  // self-pace through the SAME timed RULE→COUNTDOWN→QUESTION→RESULT flow as a native
  // pickAnswer: PickAnswerContent wraps the plugin and already owns the plugin
  // countdown + result-screen handling, and _showSelfPacedQuestion's showResultTimeout
  // is the only thing that advances a self-paced round to RESULT — so without it the
  // plugin never reaches quiz-status 5 and the phone hangs on "Submitted" (AHAM-769).
  // Without a time limit there is no countdown to end the round; the timed flow's
  // timer would be NaN and snap straight to RESULT, so keep those at QUESTION_SCREEN
  // and let the plugin reveal on its own submission.
  if (slide.type !== 'pickAnswer') {
    return _hasSelfPacedTimeLimit(slide) ? QuizStatuses.RULE_SCREEN : QuizStatuses.QUESTION_SCREEN
  }
  return QuizStatuses.RULE_SCREEN
}

function playSelfPacedQuizSlideV2(presentation, slide) {
  clearSelfPaceTimeouts()

  // If the presentation not enable Self-paced mode,
  // or not join presentation,
  // or not quiz slide, skip
  if (_isAudienceFormShowing()) return
  const defaultQuizStatus = getSelfPacedQuizStatus(presentation, slide)
  if (defaultQuizStatus === undefined) return

  _switchQuizScreen(defaultQuizStatus)

  if (defaultQuizStatus === QuizStatuses.RULE_SCREEN) {
    _prepareToShowQuestion(presentation, slide)
  }
}

function playSelfPacedQuizSlide(presentation, slide) {
  if (store.getters['featureToggles/canFixSubmitQuizIssue']) {
    return playSelfPacedQuizSlideV2(presentation, slide)
  }
  return playSelfPacedQuizSlideV1(presentation, slide)
}

export default {
  playSelfPacedQuizSlide,
  clearSelfPaceTimeouts,
  getSelfPacedQuizStatus,
}
